export const FETCH_DEPARTMENT_GROUP_REQUEST = 'FETCH_DEPARTMENT_GROUP_REQUEST';
export const FETCH_DEPARTMENT_GROUP_SUCCESS = 'FETCH_DEPARTMENT_GROUP_SUCCESS';
export const FETCH_DEPARTMENT_GROUP_FAILURE = 'FETCH_DEPARTMENT_GROUP_FAILURE';

export const ADD_DEPARTMENT_GROUP_REQUEST = 'ADD_DEPARTMENT_GROUP_REQUEST';
export const ADD_DEPARTMENT_GROUP_SUCCESS = 'ADD_DEPARTMENT_GROUP_SUCCESS';
export const ADD_DEPARTMENT_GROUP_FAILURE = 'ADD_DEPARTMENT_GROUP_FAILURE';

export const UPDATE_DEPARTMENT_GROUP_REQUEST = 'UPDATE_DEPARTMENT_GROUP_REQUEST';
export const UPDATE_DEPARTMENT_GROUP_SUCCESS = 'UPDATE_DEPARTMENT_GROUP_SUCCESS';
export const UPDATE_DEPARTMENT_GROUP_FAILURE = 'UPDATE_DEPARTMENT_GROUP_FAILURE';

export const DELETE_DEPARTMENT_GROUP_REQUEST = 'DELETE_DEPARTMENT_GROUP_REQUEST';
export const DELETE_DEPARTMENT_GROUP_SUCCESS = 'DELETE_DEPARTMENT_GROUP_SUCCESS';
export const DELETE_DEPARTMENT_GROUP_FAILURE = 'DELETE_DEPARTMENT_GROUP_FAILURE';

export const DEPARTMENT_GROUP_FORM_ERROR = 'DEPARTMENT_GROUP_FORM_ERROR';
export const DEPARTMENT_GROUP_FORM_SUCCESS = 'DEPARTMENT_GROUP_FORM_SUCCESS';
export const SET_DEPARTMENT_GROUP_EDIT = 'SET_DEPARTMENT_GROUP_EDIT';
export const CLEAR_DEPARTMENT_GROUP_EDIT = 'CLEAR_DEPARTMENT_GROUP_EDIT'; 